import { QuickBuyPageState } from 'src/lib/trade/types/Trade.types';

const DEFAULTS: QuickBuyPageState = {
  assetCode: 'BTC',
  allowAssetChange: true,
  allowPaymentChange: true,
};

export { DEFAULTS };
